export default __webpack_public_path__ + "static/media/star_orange.bd48336a.png";